import { useParams } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { Suspense, useState } from 'react'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Row,
  Space,
  theme,
  Typography,
} from 'antd'
import { errorResponse } from '../../lib/errorResponse'
import { gutter } from '../../lib/layout'
import { FileExcelOutlined } from '@ant-design/icons'
import { LoadingAnimation } from '../LoadingAnimation'
import { FileInputFormItem } from './FileInputFormItem'

export function StepUploadHealthInsuranceDocuments({
  onboarding,
  sessionToken,
  goToNext,
  goToNextText,
  goToPrevious,
}) {
  const { companyUid } = useParams()
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const { token } = theme.useToken()

  async function onSubmit() {
    setLoading(true)
    try {
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  async function uploading(upload) {
    setLoading(upload)
  }

  const [form] = Form.useForm()

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      <Row gutter={gutter}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontSize: token.fontSize,
                paddingContentHorizontal: token.paddingContentHorizontal,
                controlHeight: token.controlHeight,
                borderRadius: token.borderRadius,
              },
            },
          }}
        >
          <Col span={24}>
            <Typography.Paragraph>
              <Trans
                i18nKey="frontend:onboarding.healthInsuranceUploadDescription"
                components={{ strong: <strong /> }}
                values={{ companyName: onboarding.company.name }}
              />
            </Typography.Paragraph>
          </Col>
          <Col span={24}>
            <Suspense fallback={<LoadingAnimation />}>
              <FileInputFormItem
                buttonText={
                  <Space>
                    <FileExcelOutlined />
                    {t('frontend:onboarding.healthInsuranceChooseFile')}
                  </Space>
                }
                name={['fileList']}
                parentPath={`onboarding/${companyUid}/u1LevyHealthInsuranceDocuments/`}
                maxCount={10}
                setLoading={uploading}
                sessionToken={sessionToken}
              />
            </Suspense>
          </Col>
        </ConfigProvider>

        <Col span={24} style={{ textAlign: 'right' }}>
          <Space>
            <Button type="text" onClick={() => goToPrevious()}>
              {t('frontend:common.back')}
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {goToNextText || t('frontend:onboarding.next')}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  )
}
